module.exports = __webpack_public_path__ + "static/media/staffdoc.63944686.svg";